import fetchHelper from 'library/FetchHelper'
import { API_ASDI_CMS_BASE_URL } from 'config/constants'

export interface Props {
  payload: any
  cbs?: (input: any) => void
  cbe?: (input: any) => void
}

export function useCreateNotiToken(payload: any, cbs?: any, cbe?: any) {
  try {
    fetchHelper
      .fetch(`${API_ASDI_CMS_BASE_URL}/notification/token`, {
        method: 'POST',
        body: JSON.stringify(payload),
      })
      .then(([resp, status]: any) => {
        if (status === 200) {
          if (cbs) cbs(resp.data)
        } else if (cbe) cbe(resp)
      })
  } catch (error) {
    console.error('createNotiToken', error)
  }

  return null
}
